export default __webpack_public_path__ + "static/media/moltensteelslash6.e46192a6.png";